import { render, staticRenderFns } from "./yiliao.vue?vue&type=template&id=2467d291&scoped=true&"
import script from "./yiliao.vue?vue&type=script&lang=js&"
export * from "./yiliao.vue?vue&type=script&lang=js&"
import style0 from "./yiliao.vue?vue&type=style&index=0&id=2467d291&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467d291",
  null
  
)

export default component.exports